import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SchoolActivity, SchoolActivityInstance } from '../../models';
import { LocationsService } from 'app/services/locations.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sp-activity',
	templateUrl: './activity.component.html',
	styleUrls: ['./activity.component.scss'],
})
export class ActivityComponent implements OnInit {
	@Input() activity!: SchoolActivity;
	@Input() instance!: SchoolActivityInstance;
	@Input() isSelected = false;
	@Output() selected: EventEmitter<SchoolActivityInstance> = new EventEmitter<SchoolActivityInstance>();
	isFull = false;
	studentCapacity = 'No capacity limits';
	locationsMap$ = this.locationsService.LocationMapWithPinnableDataByLocationId$;

	constructor(private locationsService: LocationsService) {}

	ngOnInit(): void {
		this.locationsService.refreshLocationsIfEmpty();
		if (this.activity.max_attendees) {
			const currentAttendes = this.instance.current_num_attendees || 0;

			this.isFull = this.activity.max_attendees > 0 && currentAttendes >= this.activity.max_attendees;
			this.studentCapacity = `${currentAttendes}/${this.activity.max_attendees} students`;
		}
	}

	onSelectActivity(): void {
		this.isSelected = !this.isSelected;
		this.selected.emit(this.instance);
	}
}
